import { CalendarItemKind } from '../../../../constants/calendar'
import { CALENDAR_GRID_LABEL_SEPARATOR } from '../../../../constants/calendarGrid'
import {
  CALENDAR_ITEM_KIND_VARIANT,
  CALENDAR_LIST_SEPARATOR,
} from '../../Calendar.constants'
import { getCalendarRequestLabel } from '../../Calendar.utils'

import {
  getCalendarDetailsLabel,
  getCalendarPersonList,
} from './useCalendarItemsLoader.utils.labels'

function getCalendarStepsLabel(steps) {
  return steps.map(step => step.title).join(CALENDAR_LIST_SEPARATOR)
}

function getCalendarTaskGroupTitle({ count, request, t }) {
  return [request.number, t('Calendar.StepsChipKey', { count })].join(
    CALENDAR_GRID_LABEL_SEPARATOR
  )
}

// TODO: read the commit type and the managers from their CAL-01 §11.1 fields
// once the spec lists them (TM-01-08).
function toCalendarGridTaskStep({
  date,
  request,
  step: {
    can_edit: canEdit,
    commit_type: commitType,
    deadline,
    done,
    id,
    title,
    yesno,
  },
}) {
  return {
    canEdit,
    commitType,
    date,
    deadline,
    id,
    isDone: done,
    kind: CalendarItemKind.taskDeadline,
    request,
    title,
    url: request.url,
    yesno,
  }
}

export function toCalendarGridTaskDeadline(task) {
  const step = toCalendarGridTaskStep({
    date: task.date,
    request: task.request,
    step: task,
  })

  return {
    ...step,
    card: {
      details: getCalendarDetailsLabel({
        people: getCalendarPersonList(task.manager),
        request: task.request,
      }),
      steps: [step],
      title: getCalendarRequestLabel(task.request),
    },
    isAllDay: true,
    isDraggable: task.can_edit,
    secondaryLabel: task.request.number,
    stepIndex: task.step_index,
    stepTotal: task.step_total,
    variant: CALENDAR_ITEM_KIND_VARIANT[task.kind],
  }
}

export function toCalendarGridTaskGroup(
  { count, date, id, items, kind, request },
  t
) {
  const steps = items.map(step =>
    toCalendarGridTaskStep({ date, request, step })
  )

  return {
    card: {
      details: getCalendarDetailsLabel({
        people: getCalendarPersonList(request.manager),
        request,
      }),
      steps,
      title: getCalendarRequestLabel(request),
    },
    date,
    id,
    isAllDay: true,
    kind,
    popover: { subItems: steps },
    secondaryLabel: getCalendarStepsLabel(items),
    title: getCalendarTaskGroupTitle({ count, request, t }),
    url: request.url,
    variant: CALENDAR_ITEM_KIND_VARIANT[kind],
  }
}
